import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import {
  addReportIssue,
  editReportIssue,
  fetchIdReportIssue,
  selectIdReportIssue,
  selectLoading,
} from "./inventorySlice";
import {
  fetchReasonCode,
  selectReasonCode,
} from "../miscellaneous/MiscellaneousSlice";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportIssuePage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdReportIssue);
  const dataReason = useSelector(selectReasonCode);

  const { id } = useParams();

  const [showCreate, setShowCreate] = useState(false);
  const [showResolve, setShowResolve] = useState(false);
  const [row, setRow] = useState(null);

  //
  const [formValues, setFormValues] = useState({
    vin: {
      value: "",
      error: false,
      required: "N",
    },
    issue_date: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    hold_reason: {
      value: "",
      error: false,
      required: "N",
    },
    hold_reason_code: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    resolve_date: {
      value: "",
      error: false,
      required: "N",
    },
    resolve_remarks: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      // await dispatch(fetchIdReportIssue(id));

      // await dispatch(
      //   fetchReasonCode({
      //     is_enable: "Y",
      //     pageNo: 1,
      //     pageSize: -1,
      //   })
      // );
    }
    fetchMyAPI();
  }, [dispatch]);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }
    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    if (row === null) {
      const params = {
        vehicle_id: dataId.vehicle_id,
        inspection_result: "NG",
        issue_date: formValues.issue_date.value,
        remarks: formValues.remarks.value,
        hold_reason: formValues.hold_reason.value,
      };

      try {
        const response = await dispatch(addReportIssue(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await window.location.reload();
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const params = {
        reportissue_id: row.reportissue_id,
        vehicle_id: dataId.vehicle_id,
        inspection_result: "NG",
        issue_date: formValues.issue_date.value,
        remarks: formValues.remarks.value,
        hold_reason: formValues.hold_reason.value,
      };
      try {
        const response = await dispatch(editReportIssue(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await window.location.reload();
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };
  const handleResolve = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      reportissue_id: row.reportissue_id,
      vehicle_id: dataId.vehicle_id,
      inspection_result: "OK",
      resolve_date: formValues.resolve_date.value,
      resolve_remarks: formValues.resolve_remarks.value,
    };
    try {
      const response = await dispatch(editReportIssue(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        {row.inspection_result === "NG" && (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
            >
              <div className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3">
                <span
                  className="svg-icon svg-icon-md svg-icon-light"
                  onClick={() => {
                    setRow(row);
                    setFormValues({
                      ...formValues,
                      issue_date: {
                        value: moment(row.issue_date).format("YYYY-MM-DD"),
                        error: false,
                        required: "N",
                      },
                      hold_reason: {
                        value: row.hold_reason,
                        error: false,
                        required: "N",
                      },
                      hold_reason_code: {
                        value: row.hold_reason_code,
                        error: false,
                        required: "N",
                      },
                      remarks: {
                        value: row.remarks,
                        error: false,
                        required: "N",
                      },
                    });
                    setShowCreate(true);
                  }}
                >
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                </span>
              </div>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Resove</Tooltip>}
            >
              <div className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3">
                <span
                  className="svg-icon svg-icon-md svg-icon-light"
                  onClick={() => {
                    setRow(row);
                    setFormValues({
                      ...formValues,
                      resolve_date: {
                        value: moment(row.resolve_date).format("YYYY-MM-DD"),
                        error: false,
                        required: "N",
                      },

                      resolve_remarks: {
                        value: row.resolve_remarks,
                        error: false,
                        required: "N",
                      },
                    });
                    setShowResolve(true);
                  }}
                >
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
                  />
                </span>
              </div>
            </OverlayTrigger>
          </div>
        )}
      </>
    );
  };

  const columns = [
    {
      text: "Issue Date",
      dataField: "issue_date",
      headerAlign: "center",
      formatter: formatDate,
    },
    {
      text: "Hold Reason",
      dataField: "hold_reason_code",

      headerAlign: "center",
    },
    {
      text: "Reason Remarks",
      dataField: "remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Inspection Results",
      dataField: "inspection_result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Resolved Date",
      dataField: "resolve_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
    },
    {
      text: "Resolution Remark",
      dataField: "resolve_remarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const handleClose = () => {
    setShowCreate(false);
    setShowResolve(false);
    setRow(null);

    setFormValues({
      vin: {
        value: "",
        error: false,
        required: "N",
      },
      issue_date: {
        value: dateDefault,
        error: false,
        required: "N",
      },
      hold_reason: {
        value: "",
        error: false,
        required: "N",
      },
      hold_reason_code: {
        value: "",
        error: false,
        required: "N",
      },
      remarks: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_date: {
        value: "",
        error: false,
        required: "N",
      },
      resolve_remarks: {
        value: "",
        error: false,
        required: "N",
      },
    });
  };

  const handleReasonType = (e, params) => {
    const value = params.value;
    const name = params.label;
    const desc = params.desc;
    setFormValues({
      ...formValues,
      ["hold_reason"]: {
        ...formValues["hold_reason"],
        value,
      },
      ["hold_reason_name"]: {
        ...formValues["hold_reason_name"],
        value: name,
      },
      ["remarks"]: {
        ...formValues["remarks"],
        value: desc,
      },
    });
  };

  const reasonOptions = dataReason.map((e) => {
    return {
      value: e.reasoncode_id,
      label: e.reasoncode_code,
      desc: e.reasoncode_description,
    };
  });

  const index = reasonOptions.findIndex(
    (obj) => obj.value === formValues.hold_reason.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className=" justify-content-between">
                <p className=" font-size-h3 text-title-primary-2 font-weight-boldest">
                  VIN : {dataId.vin}
                </p>
              </div>
              <Form>
                <Form.Group as={Row}>
                  <Col sm={6}>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Product Code</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.product_code}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Vehicle Name</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.product_description}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Model Code</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.model_code}
                          disabled
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Model Name</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.model_name}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  {/* Right Row */}
                  <Col sm={6}>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Color Code</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.color_code}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Color Name</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.color_name}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Accessories Installed</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          value={dataId.inbound_rule === "Y" ? "Yes" : "No"}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Form.Group>
              </Form>

              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
                bootstrap4
                
                keyField="reportissue_id"
                data={dataId.issues === null ? [] : dataId.issues}
                columns={columns}
                hover
              />

              <Row className="mt-6 justify-content-end">
                <Button
                  variant="outline-primary"
                  onClick={(e) => {
                    setShowCreate(true);
                  }}
                >
                  Create Report Issue
                </Button>
              </Row>
            </CardBody>
          </Card>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showCreate}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                {row === null ? "Create " : "Edit"} Report Issue
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="VIN"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="vin"
                      value={dataId.vin}
                      onChange={handleChange}
                      disabled
                    />
                    <RedditTextField
                      label="Issue Date"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="issue_date"
                      value={formValues.issue_date.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Autocomplete
                      disablePortal
                      name="Hold Reason"
                      options={reasonOptions}
                      getOptionLabel={(option) => option.label.toString()}
                      disableClearable={true}
                      onChange={handleReasonType}
                      value={reasonOptions[index]}
                      renderInput={(params) => (
                        <RedditTextField
                          className={classes.margin}
                          {...params}
                          label="Hold Reason"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select"
                          name="hold_reason"
                        />
                      )}
                    />
                    <RedditTextField
                      label="Remarks"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="text"
                      size="small"
                      fullWidth
                      name="remarks"
                      value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>

              <Button variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showResolve}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Resolve
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="VIN"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="vin"
                      value={dataId.vin}
                      onChange={handleChange}
                      disabled
                    />
                    <RedditTextField
                      label="Resolve Date"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="resolve_date"
                      value={formValues.resolve_date.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Resolve Remarks"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="text"
                      size="small"
                      fullWidth
                      name="resolve_remarks"
                      value={formValues.resolve_remarks.value}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleResolve}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};
